var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activeDetail active" },
    [
      _c(
        "van-cell-group",
        { staticClass: "info" },
        [
          _c("van-cell", { attrs: { title: "活动名称" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" " + _vm._s(_vm.campaign.Name))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "活动日期" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(
                _vm._s(
                  (_vm.campaign.U_RangeTime || "")
                    .replace(/-/g, "/")
                    .replace(",", "-")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "活动地点" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" " + _vm._s(_vm.campaign.U_CampPlace))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "邀请人数" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" " + _vm._s(_vm.campaign.U_InvitedCnt))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "集客目标" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" " + _vm._s(_vm.campaign.U_FansTarget))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "销售目标" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" " + _vm._s(_vm.campaign.U_SaleTarget))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "讲师姓名" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" " + _vm._s(_vm.campaign.U_TeacherName))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "合作伙伴" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" " + _vm._s(_vm.campaign.U_Partner))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "活动类型" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" " + _vm._s(_vm.campaign.campTypeName))
            ])
          ]),
          _vm._v(" "),
          _vm.showTicket
            ? _c("van-cell", {
                attrs: { center: "", title: "发券开关" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "right-icon",
                      fn: function() {
                        return [
                          _c("van-switch", {
                            attrs: {
                              loading: _vm.loadingTicket,
                              disabled: !_vm.campaign.is_coupon,
                              value: _vm.campaign.is_coupon,
                              "active-color": "#ee0a24",
                              "inactive-color": "#dcdee0",
                              size: "20px"
                            },
                            on: { input: _vm.onUpdateValue }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3911735558
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c(
            "van-cell",
            {
              attrs: { title: "活动主题" },
              on: {
                click: function($event) {
                  _vm.showZhuti = !_vm.showZhuti
                }
              }
            },
            [
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                slot: "right-icon"
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showZhuti
            ? _c("div", {
                staticClass: "cell-content",
                domProps: { innerHTML: _vm._s(_vm.campaign.U_Theme) }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c(
            "van-cell",
            { attrs: { title: "活动目的" } },
            [
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                on: {
                  click: function($event) {
                    _vm.showMudi = !_vm.showMudi
                  }
                },
                slot: "right-icon"
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showMudi
            ? _c("div", {
                staticClass: "cell-content",
                domProps: { innerHTML: _vm._s(_vm.campaign.U_Purpose) }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c(
            "van-cell",
            { attrs: { title: "讲师介绍" } },
            [
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                on: {
                  click: function($event) {
                    _vm.showJieshao = !_vm.showJieshao
                  }
                },
                slot: "right-icon"
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showJieshao
            ? _c("div", {
                staticClass: "cell-content",
                domProps: { innerHTML: _vm._s(_vm.campaign.U_Instructor) }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c(
            "van-cell",
            { attrs: { title: "场地介绍" } },
            [
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                on: {
                  click: function($event) {
                    _vm.showChangdi = !_vm.showChangdi
                  }
                },
                slot: "right-icon"
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showChangdi
            ? _c("div", {
                staticClass: "cell-content",
                domProps: { innerHTML: _vm._s(_vm.campaign.U_Venue) }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            { attrs: { title: "流程介绍" } },
            [
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                on: {
                  click: function($event) {
                    _vm.showLiucheng = !_vm.showLiucheng
                  }
                },
                slot: "right-icon"
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showLiucheng
            ? _c(
                "div",
                { staticClass: "table van-hairline--surround" },
                [
                  _c("div", { staticClass: "table-title flex" }, [
                    _c("p", { staticClass: "item1" }, [_vm._v("序号")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item2" }, [_vm._v("日期")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item2" }, [_vm._v("时间")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item3" }, [_vm._v("内容")])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.processList, function(item, index) {
                    return [
                      _c(
                        "ul",
                        { staticClass: "table-content flex van-hairline--top" },
                        [
                          _c(
                            "li",
                            { staticClass: "item1 van-hairline--right" },
                            [_vm._v(_vm._s(index + 1))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "item2 van-hairline--right" },
                            [
                              _vm._v(
                                _vm._s(_vm._f("getActiveDate")(item.U_Flow))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "item2 van-hairline--right" },
                            [
                              _vm._v(
                                _vm._s(_vm._f("getActiveTime")(item.U_Flow))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("li", { staticClass: "item3 flex-column" }, [
                            _c(
                              "span",
                              { staticClass: "item1 content common-limit-2" },
                              [_vm._v(_vm._s(item.U_Details))]
                            )
                          ])
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [
                  _vm._v("活动预算")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mini-text" }, [
                  _vm._v(
                    "（未税" +
                      _vm._s(
                        _vm
                          .$numeral((_vm.totalBudget.amount || 0).toFixed(2))
                          .format("0,0.00")
                      ) +
                      "，含税" +
                      _vm._s(
                        _vm
                          .$numeral((_vm.totalBudget.unamount || 0).toFixed(2))
                          .format("0,0.00")
                      ) +
                      "）"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                on: {
                  click: function($event) {
                    _vm.showYusuan = !_vm.showYusuan
                  }
                },
                slot: "right-icon"
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.showYusuan
            ? _c(
                "div",
                { staticClass: "table van-hairline--surround" },
                [
                  _c("div", { staticClass: "table-title flex" }, [
                    _c("p", { staticClass: "item1" }, [_vm._v("序号")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item2" }, [_vm._v("名称")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item1" }, [_vm._v("数量")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item3" }, [_vm._v("未税费用")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item3" }, [_vm._v("含税费用")])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.budgetList, function(item, index) {
                    return [
                      _c(
                        "ul",
                        { staticClass: "table-content flex van-hairline--top" },
                        [
                          _c(
                            "li",
                            { staticClass: "item1 van-hairline--right" },
                            [_vm._v(_vm._s(index + 1))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "item2 van-hairline--right" },
                            [_vm._v(_vm._s(item.Name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "item1 van-hairline--right" },
                            [
                              _vm._v(
                                _vm._s(_vm.$numeral(item.U_Qty).format("0,0"))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "item3 van-hairline--right" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$numeral(item.U_Amount).format("0,0.00")
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("li", { staticClass: "item3 flex" }, [
                            _c("p", { staticClass: "item1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$numeral(item.U_AmountAftTax)
                                    .format("0,0")
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "table-content flex van-hairline--top" },
                    [
                      _c("li", { staticClass: "item3 van-hairline--right" }, [
                        _vm._v("合计")
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item1 van-hairline--right" }, [
                        _vm._v(
                          _vm._s(
                            _vm
                              .$numeral(_vm.totalBudget.count || 0)
                              .format("0,0")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item3 van-hairline--right" }, [
                        _vm._v(
                          _vm._s(
                            _vm
                              .$numeral(
                                (_vm.totalBudget.amount || 0).toFixed(2)
                              )
                              .format("0,0.00")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item3" }, [
                        _vm._v(
                          _vm._s(
                            _vm
                              .$numeral(
                                (_vm.totalBudget.unamount || 0).toFixed(2)
                              )
                              .format("0,0.00")
                          )
                        )
                      ])
                    ]
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [
                  _vm._v("物料申请")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mini-text" }, [
                  _vm._v(
                    "（合计数量：" +
                      _vm._s(_vm.$numeral(_vm.totalMaterial).format("0,0")) +
                      "）"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                on: {
                  click: function($event) {
                    _vm.showWuliao = !_vm.showWuliao
                  }
                },
                slot: "right-icon"
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.showWuliao
            ? _c(
                "div",
                { staticClass: "table van-hairline--surround" },
                [
                  _c("div", { staticClass: "table-title flex" }, [
                    _c("p", { staticClass: "item1" }, [_vm._v("序号")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item3" }, [_vm._v("产品一级分类")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item2" }, [_vm._v("产品名称")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item1" }, [_vm._v("数量")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "item3" }, [_vm._v("归还日期")])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.materialList, function(item, index) {
                    return [
                      _c(
                        "ul",
                        { staticClass: "table-content flex van-hairline--top" },
                        [
                          _c(
                            "li",
                            { staticClass: "item1 van-hairline--right" },
                            [_vm._v(_vm._s(index + 1))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "item3 van-hairline--right" },
                            [_vm._v(_vm._s(item.U_MaterialClass))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "item2 van-hairline--right" },
                            [_vm._v(_vm._s(item.Name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "item1 van-hairline--right" },
                            [
                              _vm._v(
                                _vm._s(_vm.$numeral(item.U_Qty).format("0,0"))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("li", { staticClass: "item3 flex" }, [
                            _c("p", { staticClass: "item1" }, [
                              _vm._v(_vm._s(item.U_ReturnDate))
                            ])
                          ])
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showWuliao
        ? _c(
            "van-cell-group",
            { staticClass: "group" },
            [
              _c("van-cell", { attrs: { title: "图片" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "clear" },
                [
                  _vm._l(_vm.materialImgList, function(item, index) {
                    return [
                      _c("p", { staticClass: "upload-img fl" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.$config.serverURL + "upload/" + item.U_url
                          },
                          on: {
                            click: function($event) {
                              return _vm.previewList(_vm.materialImgList, index)
                            }
                          }
                        })
                      ])
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c(
            "van-cell",
            { attrs: { title: "审批记录" } },
            [
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                on: {
                  click: function($event) {
                    _vm.showShenpi = !_vm.showShenpi
                  }
                },
                slot: "right-icon"
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showShenpi
            ? _c(
                "ul",
                { staticClass: "steps" },
                [
                  _vm._l(_vm.flowRecordList, function(item) {
                    return [
                      _c(
                        "li",
                        { staticClass: "step" },
                        [
                          item.approvalFlow && item.approvalFlow.U_Status == "N"
                            ? _c("van-icon", {
                                staticClass: "step-icon",
                                attrs: {
                                  name: "clear",
                                  color: "#e83c39",
                                  size: "20px"
                                }
                              })
                            : item.approvalFlow &&
                              item.approvalFlow.U_Status == "Y"
                            ? _c("van-icon", {
                                staticClass: "step-icon",
                                attrs: {
                                  name: "checked",
                                  color: "#02c316",
                                  size: "20px"
                                }
                              })
                            : _c("van-icon", {
                                staticClass: "step-icon",
                                attrs: {
                                  name: "play-circle",
                                  color: "#8bc34a",
                                  size: "20px"
                                }
                              }),
                          _vm._v(" "),
                          _c("p"),
                          _c("p", { staticClass: "flex" }, [
                            _c("span", { staticClass: "item1" }, [
                              _vm._v(_vm._s(item.approvalFlow.createTime))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "item1" }, [
                              _vm._v(_vm._s(item.approvalFlow.salesName))
                            ])
                          ]),
                          _vm._v(" "),
                          item.approvalFlow &&
                          (item.approvalFlow.U_Status == "M" ||
                            item.approvalFlow.U_Status == "S")
                            ? _c("p", [
                                _vm._v(
                                  "提交备注：" +
                                    _vm._s(item.approvalFlow.U_Remark)
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.approvalFlow && item.approvalFlow.U_Status == "D"
                            ? _c("p", [
                                _vm._v(_vm._s(item.approvalFlow.U_Remark))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.approvalFlow &&
                          (item.approvalFlow.U_Status == "N" ||
                            item.approvalFlow.U_Status == "Y")
                            ? _c("p", [
                                _vm._v(
                                  "审批备注：" +
                                    _vm._s(item.approvalFlow.U_Remark)
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "clear" },
                            [
                              _vm._l(item.imgList, function(img, index) {
                                return [
                                  _c("img", {
                                    staticClass: "step-img fl",
                                    attrs: {
                                      src:
                                        _vm.$config.serverURL +
                                        "upload/" +
                                        img.U_url
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.previewList(
                                          item.imgList,
                                          index
                                        )
                                      }
                                    }
                                  })
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showShenpi && _vm.flowRecordList.length == 0
            ? _c("p", { staticClass: "text-center" }, [_vm._v("暂无审批记录")])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isApproval
        ? _c(
            "van-cell-group",
            { staticClass: "group" },
            [
              _c("van-cell", { attrs: { title: "审批备注" } }),
              _vm._v(" "),
              _c("van-field", {
                staticClass: "textarea van-hairline--surround",
                attrs: {
                  type: "textarea",
                  placeholder: "请输入备注内容描述",
                  rows: "3",
                  autosize: ""
                },
                on: {
                  input: function($event) {
                    return _vm.limitLength(1024, "remark")
                  }
                },
                model: {
                  value: _vm.remark,
                  callback: function($$v) {
                    _vm.remark = $$v
                  },
                  expression: "remark"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "clear" },
                [
                  _vm._l(_vm.imgs, function(img, index) {
                    return [
                      _c(
                        "p",
                        { staticClass: "upload-img fl" },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.$config.serverURL + "upload/" + img,
                              alt: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.previewList(_vm.imgs, index)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("van-icon", {
                            staticClass: "del-icon",
                            attrs: {
                              name: "clear",
                              color: "#e83c39",
                              size: "20px"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delImg(index)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }),
                  _vm._v(" "),
                  _c(
                    "van-uploader",
                    {
                      staticClass: "upload fl",
                      attrs: { "after-read": _vm.afterRead, multiple: "" }
                    },
                    [
                      _c("van-icon", { attrs: { name: "plus" } }),
                      _vm._v(" "),
                      _c("p", [_vm._v("上传图片")])
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group", attrs: { multiple: "" } },
        [
          _c("van-cell", { attrs: { title: "活动签到二维码" } }),
          _vm._v(" "),
          _c("div", { staticClass: "qrcode" }, [
            _c("img", {
              attrs: { src: _vm.qrCode },
              on: {
                click: function($event) {
                  return _vm.previewQr(_vm.qrCode)
                }
              }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [
                  _vm._v("参与成员")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mini-text c-red" }, [
                  _vm._v("（" + _vm._s(_vm.total) + "人）")
                ])
              ]),
              _vm._v(" "),
              _c("van-icon", {
                staticClass: "custom-icon",
                attrs: { slot: "right-icon", name: "arrow-down", size: "20px" },
                on: {
                  click: function($event) {
                    _vm.showChengyuan = !_vm.showChengyuan
                  }
                },
                slot: "right-icon"
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.showChengyuan
            ? _c(
                "van-list",
                {
                  attrs: {
                    finished: _vm.finished,
                    "immediate-check": false,
                    "finished-text": "没有更多了"
                  },
                  on: { load: _vm.getMemberList },
                  model: {
                    value: _vm.loading,
                    callback: function($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading"
                  }
                },
                [
                  _vm._l(_vm.list, function(item) {
                    return [
                      _c("div", { staticClass: "list-card" }, [
                        _c("div", { staticClass: "flex" }, [
                          _c("p", { staticClass: "item1" }, [
                            _vm._v("姓名：" + _vm._s(item.custName))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "item1" }, [
                            _vm._v("性别：" + _vm._s(item.sexName))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex" }, [
                          _c("p", { staticClass: "item1" }, [
                            _vm._v("手机号：" + _vm._s(item.U_Mobile))
                          ]),
                          _vm._v(" "),
                          item.U_UploadedShow
                            ? _c(
                                "p",
                                {
                                  staticClass: "item1 get-work",
                                  on: {
                                    click: function($event) {
                                      return _vm.seeWorks(item.U_CampMemberId)
                                    }
                                  }
                                },
                                [_vm._v("查看作品")]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isApply && _vm.hasModifyAuth
        ? _c("div", { staticClass: "bottom-btn flex" }, [
            _vm.campaign.U_ApprovalStatus == "D" ||
            _vm.campaign.U_ApprovalStatus == "N" ||
            (_vm.campaign.U_ApprovalStatus == "Y" && _vm.campaign.rptCnt <= 0)
              ? _c(
                  "div",
                  { staticClass: "item1 btn save", on: { click: _vm.toReply } },
                  [_vm._v("修改")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "item1 btn sub", on: { click: _vm.getPdf } },
              [_vm._v("生成pdf")]
            ),
            _vm._v(" "),
            (_vm.campaign.U_ApprovalStatus == "W" ||
              _vm.campaign.U_ApprovalStatus == "Y") &&
            _vm.campaign.rptCnt > 0
              ? _c(
                  "div",
                  {
                    staticClass: "item1 btn save",
                    on: { click: _vm.toReport }
                  },
                  [_vm._v("活动报告")]
                )
              : _vm._e()
          ])
        : _vm.isApproval
        ? _c("div", { staticClass: "bottom-btn flex" }, [
            _vm.campaign.U_ApprovalStatus == "W" && _vm.hasAuditAuth
              ? _c(
                  "div",
                  {
                    staticClass: "item1 btn save",
                    on: {
                      click: function($event) {
                        return _vm.toShenpi(_vm.submitFlag.refuse)
                      }
                    }
                  },
                  [_vm._v("拒绝")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.campaign.U_ApprovalStatus == "W" && _vm.hasAuditAuth
              ? _c(
                  "div",
                  {
                    staticClass: "item1 btn sub",
                    on: {
                      click: function($event) {
                        return _vm.toShenpi(_vm.submitFlag.pass)
                      }
                    }
                  },
                  [_vm._v("审批")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.campaign.U_ApprovalStatus == "Y" && _vm.campaign.rptCnt > 0
              ? _c(
                  "div",
                  {
                    staticClass: "item1 btn save",
                    on: { click: _vm.toReport }
                  },
                  [_vm._v("活动报告")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.campaign.U_ApprovalStatus == "Y" || !_vm.hasAuditAuth
              ? _c(
                  "div",
                  { staticClass: "item1 btn sub", on: { click: _vm.getPdf } },
                  [_vm._v("生成pdf")]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isApply && !_vm.isApproval && _vm.overLoad
        ? _c("div", { staticClass: "bottom-btn flex" }, [
            _c(
              "div",
              { staticClass: "item1 btn sub", on: { click: _vm.getPdf } },
              [_vm._v("生成pdf")]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36844180", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36844180","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/activeDetail.vue
// module id = null
// module chunks = 